export default {
  activity_workTransport_01: {
    title:
      'Hvis jeg skulle bestilt en jobbreise i dag vil jeg først vurdert mulighetene for å minimere miljøpåvirkningen',
    description: `MARKDOWN:
Kan logges hver dag så lenge du før neste jobbreise vil vurdere om du kan redusere utslippene.

Noen tips:  
1) Kan reisen erstattes av videokonferanse?  
2) Må du reise så langt?  
3)Finnes et mer miljøvennlig transportalternativ?  
4)Kan du påvirke eventet til å redusere reisebehovet for alle deltakere?`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Hvis du dropper en flytur til Europa med en typisk reiselengde på 1500km hver vei ville du spare ca 800 Kg CO\u2082e, noe som tilsvarer omtrent det samme besparelsen som om en gjennomsnittsnordmann blir veganer i ett år.

## HVORDAN BEREGNER VI CO\u2082e
- Miljøbesparelsen er basert på antakelsen om at dine jobbreiser kan reduseres med 30% ved å ta mer bevisste reisevalg på jobb.
- Dette er da en reduksjon fra gjennomsnittlige reisevaner for en ansattt på din arbeidsplass som mest sannsynlig er funnet fra en spørreundersøkelse i forkant av utfordringen. Om dette ikke er gjennomført er dataen hentet fra en bedrift som ligner på deres.
`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_workTransport_02: {
    title:
      'Jeg gjennomførte alle jobbreiser på jobb i dag med kollektivtransport',
    description:
      'Benytt kollektivtransport som buss, trikk eller tog til alle ærend for jobb i dag.',
    co2_explanation: `MARKDOWN:
## Visste du at?
- Mange byer rundt omkring i verden har forbudt biler i sentrum. Dette har blant annet ført til mindre utslipp, bedre luftkvalitet, mer liv i bykjernen og mindre ulykker for å nevne noen fordeler.

## HVORDAN BEREGNER VI CO\u2082e
- Miljøbesparelsen er beregnet ved å se på forskjellen på hvordan en gjennomsnittsperson i din bedrift reiser i arbeidstiden og en som kun benytter kollektivtransport.
- Reisevanene til en gjennomsnittsperrson på din arbeidsplass er mest sannsynlig funnet fra en spørreundersøkelse i forkant av utfordringen. Om dette ikke er gjennomført er dataen hentet fra en bedrift som ligner på deres.

## Tilleggsinformasjon
- [https://www.theguardian.com/cities/2018/sep/18/paradise-life-spanish-city-banned-cars-pontevedra](https://www.theguardian.com/cities/2018/sep/18/paradise-life-spanish-city-banned-cars-pontevedra)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_workTransport_03: {
    title: 'Jeg gjennomførte alle jobbreiser på jobb i dag med ren muskelkraft',
    description:
      'Bruk ren muskelkraft som gange, sykkel, jogging, skateboard, padling eller liknende til alle ærender for jobb i dag.',
    co2_explanation: `MARKDOWN:
## Visste du at?
- Ved å sykle eller gå kan du redusere antall biler og dermed minske forurensning, støynivå, svevestøv, giftige gasser og samtidig bidra til et vakrere bymiljø. I tillegg vil andre digge deg for at du tar det beste valget for kloden vår.

## HVORDAN BEREGNER VI CO\u2082e
- Miljøbesparelsen er beregnet ved å se på forskjellen på hvordan en gjennomsnittsperson i din bedrift reiser i arbeidstiden og en som kun benytter muskelkraft.
- Reisevanene til en gjennomsnittsperrson på din arbeidsplass er mest sannsynlig funnet fra en spørreundersøkelse i forkant av utfordringen. Om dette ikke er gjennomført er dataen hentet fra en bedrift som ligner på deres.
    `,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_workTransport_04: {
    title: 'Jeg gjennomførte alle jobbreiser på jobb i dag med elbil',
    description: 'Bruk elbil om du skal på noen ærend for jobben i dag.',
    co2_explanation: `MARKDOWN:
## Visste du at?
- Energimiksen er viktig for hvor miljøvennlig det er å kjøre en elektrisk bil. Med strømmen vi benytter i Norden er utslippene 81gram CO\u2082e per kilometer , mens en bensin eller diesebil slipper ut ca 250gram per kilometer.  Disse tallene inkluderer produksjonen av bilene.

## HVORDAN BEREGNER VI CO\u2082e
- Miljøbesparelsen er beregnet ved å se på forskjellen på hvordan en gjennomsnittsperson i din bedrift reiser i arbeidstiden og en som kun benytter elbil.
- Reisevanene til en gjennomsnittsperrson på din arbeidsplass er mest sannsynlig funnet fra en spørreundersøkelse i forkant av utfordringen. Om dette ikke er gjennomført er dataen hentet fra en bedrift som ligner på deres.
`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
};
